import type { Theme } from './light'

/**
 * Template C – Modern & Dezent
 * 
 * Modernes Design-Template mit Fokus auf Grüntöne
 * und dezenten Farben für klare, reduzierte Oberflächen
 */
export const modernTheme: Theme = {
  name: 'modern',
  colors: {
    // Primärfarben basierend auf UI-Styleguide
    primary: '#7b9d7c',
    primaryLight: '#a5d7cc',
    primaryDark: '#5e7e5f',
    
    // Sekundärfarben basierend auf UI-Styleguide
    secondary: '#a5d7cc',
    secondaryDark: '#85c7c6',
    
    // Status-Farben basierend auf UI-Styleguide
    success: '#7b9d7c',
    danger: '#ea1f0e',
    warning: '#e6b86b',
    info: '#85c7c6',
    
    // Hintergrundfarben
    background: '#ecedef',
    backgroundLight: '#ffffff',
    backgroundSecondary: '#e9ecef',
    backgroundTertiary: '#dee2e6', // Leicht dunkler als backgroundSecondary für Tabellen-Header
    backgroundDark: '#d9d9d6',
    surface: '#ffffff',
    
    // Textfarben
    text: '#1d1d1b',
    textLight: '#58757b',
    textDark: '#1d1d1b',
    textOnPrimary: '#ffffff',
    
    // UI-Elemente
    border: '#d9d9d6',
    hover: '#f6f6f8',
    focus: 'rgba(123, 157, 124, 0.25)',
    
    // Schatten
    shadowColor: 'rgba(0, 0, 0, 0.06)',
  },
  
  // Schatten-Definitionen
  shadows: {
    sm: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.04)',
    md: '0 0.5rem 1rem rgba(0, 0, 0, 0.08)',
    lg: '0 1rem 3rem rgba(0, 0, 0, 0.12)',
  },
  
  // Weitere Theme-spezifische Eigenschaften
  properties: {
    headerHeight: '60px',
    sidebarWidth: '250px',
    borderRadius: {
      sm: '0.375rem',
      md: '0.5rem',
      lg: '0.75rem',
    },
    transitions: {
      fast: '150ms ease-in-out',
      normal: '300ms ease-in-out',
      slow: '500ms ease-in-out',
    },
    fonts: {
      family: '"Inter", "Roboto", "Helvetica Neue", sans-serif',
      sizes: {
        h1: '2rem', // 32px
        h2: '1.5rem', // 24px
        h3: '1.125rem', // 18px
        body: '1rem', // 16px
        small: '0.875rem', // 14px
      },
      weights: {
        regular: '400',
        medium: '500',
        semibold: '600',
        bold: '700'
      }
    },
    buttons: {
      primary: {
        background: '#7b9d7c',
        text: '#ffffff',
        hover: '#5e7e5f'
      },
      secondary: {
        background: '#a5d7cc',
        text: '#1d1d1b',
        hover: '#85c7c6'
      },
      neutral: {
        background: '#d9d9d6',
        text: '#1d1d1b',
        hover: '#b0b0af'
      },
      success: {
        background: '#7b9d7c',
        text: '#ffffff',
        hover: '#5e7e5f'
      },
      warning: {
        background: '#e6b86b',
        text: '#1d1d1b',
        hover: '#e0d26f'
      },
      danger: {
        background: '#ea1f0e',
        text: '#ffffff',
        hover: '#cf7666'
      }
    },
    alerts: {
      info: {
        background: '#c2f1eb',
        text: '#1d1d1b',
        icon: '#018ea9'
      },
      success: {
        background: '#acd7c8',
        text: '#1d1d1b',
        icon: '#7b9d7c'
      },
      warning: {
        background: '#f1e2c1',
        text: '#1d1d1b',
        icon: '#e0d26f'
      },
      danger: {
        background: '#f6c6b8',
        text: '#1d1d1b',
        icon: '#ea1f0e'
      }
    }
  },
}
